module.exports = __webpack_public_path__ + "u3.no2.1d698267.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/u3.no2.jpg
// module id = ehpS
// module chunks = 0